import React from 'react';

import { useTreatmentFilterUpdaterContext } from '../context/TreatmentFilterContext';
import { useSortAndFilterResultsContext } from '../../SortAndFilterResults/SortAndFilterResultsContext';

import Button from '../../../../_ui/_blocks/Buttons/Button/Button';

import styles from './FilterActions.module.css';

interface Props {
    onClose: () => void;
}

const FilterActions = ({ onClose }: Props) => {
    const { clearAllFilters } = useTreatmentFilterUpdaterContext();
    const { processedData } = useSortAndFilterResultsContext();

    const numberOfTreatments = (processedData || []).length;

    return (
        <div className={styles.filterActions}>
            <Button variant="tertiary" size="small" title="Clear all filters" onClick={clearAllFilters}>
                Clear all
            </Button>
            <Button  title="View all filtered treatments" onClick={onClose} disabled={numberOfTreatments === 0}>
                Show {numberOfTreatments} Results
            </Button>
        </div>
    );
};

export default FilterActions;
